
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"Ellipse_149","x":"0","y":"0","width":"32","height":"32","filterUnits":"userSpaceOnUse"}},[_c('feOffset',{attrs:{"dy":"3"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3","result":"blur"}}),_c('feFlood',{attrs:{"flood-opacity":".161"}}),_c('feComposite',{attrs:{"operator":"in","in2":"blur"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})])]),_c('g',{attrs:{"id":"Group_20508","data-name":"Group 20508","transform":"rotate(180 522.5 305.5)"}},[_c('g',{attrs:{"transform":"rotate(180 522.5 305.5)","filter":"url(#Ellipse_149)"}},[_c('circle',{attrs:{"id":"Ellipse_149-2","data-name":"Ellipse 149","cx":"7","cy":"7","r":"7","transform":"rotate(180 11.5 10)","fill":"#fff"}})]),_c('path',{attrs:{"id":"Path_2","data-name":"Path 2","d":"M1029.863 595.483L1027.5 598l2.363 2.517","fill":"none","stroke":"#354052","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":"1.5"}})])])
          )
        }
      }
    